import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String, dismissDefinitely: String }

  close() {
    this.element.remove()

    if(this.dismissDefinitelyValue === "true") {
      App.onboardingStep.save({ name: this.idValue, seen: true })
    }
  }
}
